module.exports = __webpack_public_path__ + "../static/img/base_other.f31789f1.png";